import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPenSvg } from "./IconPenSvg.mjs";
const IconPen = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPenSvg, ...iconProps });
};
export {
  IconPen
};
